import { __, sprintf } from '@wordpress/i18n';

const searchElements = document.querySelectorAll('[data-id="eh-search"]');

searchElements.forEach(search => {
  const searchInput = search.querySelector('[data-id="live-search"]');
  const loadingSpinner = search.querySelector('[data-id="loading-spinner"]');
  const cancelIcon = search.querySelector('[data-id="cancel-icon"]');
  const searchIcon = search.querySelector('[data-id="search-icon"]');
  const form = search.querySelector('[data-id="eh-search-form"]');
  
  let ongoingRequest = null;
  
  if (searchInput && search && loadingSpinner && cancelIcon) {
    searchInput.addEventListener('input', debounce(handleInputEvent, 200));
    cancelIcon.addEventListener('click', function () {
      searchInput.value = ''; // Clear the input field
      searchInput.dispatchEvent(new Event('input')); // Trigger the input event
    });
  }

  /**
   * This functions makes sure a search for a specific input is only triggered if the input didn't change within the delay.
   */
  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      // Clear the previous timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // Set a new timeout
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }

  function handleInputEvent(event) {
    if (ongoingRequest) {
      //console.log("aborted");
      ongoingRequest.abort();
    }
    if (event.target.value.length > 1) {
      cancelIcon.style.display = 'block';
      loadingSpinner.style.display = 'block';

      //console.log("Triggered");

      const xhr = new XMLHttpRequest();
      ongoingRequest = xhr;
      xhr.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (this.status === 200) {
            const products = JSON.parse(this.responseText);
            //console.log(products);
            addFoundProducts(products, event.target.value);
          } else if (this.status === 0) {
            //console.log("Request was aborted.");
          } else {
            console.error(`Error: ${this.status} ${this.statusText}`);
          }
          loadingSpinner.style.display = 'none';
          ongoingRequest = null;
        }
      };
      xhr.onabort = function () {
        //console.log("Search aborted.");
      };
      xhr.open('GET', `${data.siteUrl}/?liveSearch=${event.target.value}`);
      xhr.send();
    } else {
      loadingSpinner.style.display = 'none';
      cancelIcon.style.display = 'none';
      const searchResultsContainer = search.querySelector('[data-id="eh-search-results-container"]');
      if (searchResultsContainer) {
        search.lastElementChild.remove();
      }
    }
  }

  function addFoundProducts(products, searchTerm) {
    let searchResultsContainer = search.querySelector('[data-id="eh-search-results-container"]');
    if (!searchResultsContainer) {
      const newSearchResultsContainer = document.createElement('div');
      newSearchResultsContainer.setAttribute('data-id', 'eh-search-results-container');
      search.appendChild(newSearchResultsContainer);
      searchResultsContainer = newSearchResultsContainer;
    }
    searchResultsContainer.innerHTML = '';

    // searchResultsContainer.addEventListener('click', () => {
    //   sendSearchInformationToMatomo(searchTerm, products.length);
    // });

    // cancelIcon.addEventListener('click', () => {
    //   sendSearchInformationToMatomo(searchTerm, products.length);
    // });

    // searchIcon.addEventListener('click', () => {
    //   sendSearchInformationToMatomo(searchTerm, products.length);
    // });

    // form.addEventListener('keydown', (event) => {
    //   if (event.key === 'Enter') {
    //     sendSearchInformationToMatomo(searchTerm, products.length);
    //   }
    // });

    if (products.length > 0) {
      const resultsTitle = document.createElement('p');
      resultsTitle.classList.add("results-title");
      resultsTitle.textContent = __('Results', 'live-search');
      searchResultsContainer.appendChild(resultsTitle);
      for (let product of products) {
        const title = product.title;
        const imgSrc = product.thumbnail;
        const link = product.link;
        const price = parseFloat(product.price).toFixed(2);
        const currency = product.currency;
        let regularPrice = null;
        let priceClasses = '';
        if (product.is_on_sale) {
          regularPrice = parseFloat(product.regular_price).toFixed(2);
          priceClasses = 'text-danger';
        }
        const regularPriceHtml = regularPrice ? `<p class="eh-search-result-item-price-regular"><span>${currency} </span>${regularPrice}</p>` : '';
        const item = document.createElement('a');
        item.setAttribute('href', link);
        item.classList.add('eh-search-result-item');
        item.innerHTML = `<figure class="eh-search-result-img-container"><img src="${imgSrc}" class="eh-search-result-item-img" /></figure><div class="eh-search-result-item-data-container"><p class="eh-search-result-item-title">${title}</p><div class="eh-search-result-item-price"><p class="${priceClasses}"><span>${currency} </span>${price}</p> ${regularPriceHtml}</div></div>`;
        searchResultsContainer.appendChild(item);
      }
      const showAllResults = document.createElement('a');
      showAllResults.setAttribute('href', '#');
      showAllResults.classList.add('eh-search-show-all-results');
      showAllResults.textContent = __('Show all results', 'live-search');
      searchResultsContainer.appendChild(showAllResults);
      showAllResults.addEventListener('click', function (event) {
        event.preventDefault();
        if (form) {
          form.submit();
        }
      });
      searchResultsContainer.appendChild(getMedicationCategoryInfo());
    } else {
      const info = document.createElement('p');
      info.classList.add('no-results-found-info');
      info.textContent = __('No search results found', 'live-search');
      searchResultsContainer.appendChild(info);

      searchResultsContainer.appendChild(getMedicationCategoryInfo());

      const linkToRecipePlatform = data.recipePlatformUrl;
      const linkToRecipePlatformLocalized = data.activeLocale === 'fr_FR' ? `${linkToRecipePlatform}/fr` : `${linkToRecipePlatform}/de`;
      const medicationInformationContainer = document.createElement('div');
      medicationInformationContainer.classList.add('medication-information-container');
      medicationInformationContainer.innerHTML = `<p class="medication-information-title">${__('Do you search for a medication', 'live-search')}?</p><p class="medication-information-body-text">${(0,_wordpress_i18n__WEBPACK_IMPORTED_MODULE_0__.sprintf)(__('Try it on our %s', 'live-search'), `<a href="${linkToRecipePlatformLocalized}"> ${__('platform for recipes', 'live-search')}</a>.`)}</p>`;
      searchResultsContainer.appendChild(medicationInformationContainer);
    }
  }

  function getMedicationCategoryInfo() {
    const medicationCategoryInfo = document.createElement('a');
    medicationCategoryInfo.classList.add('medication-category-info');
    
    const linkToMedicationCategoryPageElement = search.querySelector("#linkToMedicationCategoryPage");
    const linkToMedicationCategoryPage = linkToMedicationCategoryPageElement.getAttribute('data-url');
    medicationCategoryInfo.setAttribute("href", translateUrl(linkToMedicationCategoryPage));

    medicationCategoryInfo.textContent = __('Which medications can be ordered in the online-apo?', 'live-search');
    return medicationCategoryInfo;
  }

  function translateUrl(url) {
    const siteUrl = data.siteUrl;
    let translateUrl = url;
    if (data.activeLocale === 'fr_FR') {
      const siteUrlWithoutLanguageCode = siteUrl.replace("/fr", "");
      const page = url.replace(siteUrlWithoutLanguageCode, "");
      translateUrl = `${siteUrlWithoutLanguageCode}/fr${page}/`;
    }
    return translateUrl;
  }

  function sendSearchInformationToMatomo(searchTerm, foundItems) {
    const matomoEndpoint = "https://espaceehealth.matomo.cloud/matomo.php";
    const siteId = 11;
    const queryParams = {
      idsite: siteId,
      rec: 1,
      action_name: 'Live Search (only full seach terms): ' + searchTerm,
      search: searchTerm
    };

    if (foundItems > 0) {
      queryParams['search_count'] = foundItems;
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const trackingUrl = `${matomoEndpoint}?${queryParams}`;

    fetch(trackingUrl);
  }

});